import { render } from "./TradeRoute.vue?vue&type=template&id=4d2e48c8&scoped=true&ts=true"
import script from "./TradeRoute.vue?vue&type=script&lang=ts"
export * from "./TradeRoute.vue?vue&type=script&lang=ts"

import "./TradeRoute.vue?vue&type=style&index=0&id=4d2e48c8&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2e48c8"]])

export default __exports__